import React, { useContext, useEffect } from "react";
import { BsCheckCircle } from "react-icons/bs";
import { RiNumber1, RiNumber2, RiNumber3, RiNumber4 } from "react-icons/ri";
import Link from "next/link";
import Title from "~/shared/Title";
import Button from "~/shared/Btn";
import { Footer, SuccessContainer, SuccessMessage, TimeLineContent } from "./styles";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import Head from "next/head";

const iconStyle = {
    background: "#FE8418",
    color: "#FFF",
};

const Success = () => {
    const { clearLocalStorageSteps } = useContext(MultiSelectFormContext);

    clearLocalStorageSteps([
        "addressAndDate",
        "confirmation",
        "briefing_padrao",
        "briefing_imobiliario",
        "values",
        "redirect",
    ]);

    const jobId = localStorage.getItem("jobId");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Head>
                <title>Solicitação publicada - Fotop Serviços</title>
            </Head>
            <SuccessContainer>
                <BsCheckCircle size={72} color="#0DD735" />
                <p>Solicitação realizada</p>
            </SuccessContainer>
            <SuccessMessage>
                <Title level="2">Job solicitado com sucesso para a nossa base de fotógrafos qualificados!!</Title>
            </SuccessMessage>
            <TimeLineContent>
                <VerticalTimeline lineColor="#FE8418" layout="1-columns">
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        iconStyle={iconStyle}
                        icon={<RiNumber1 />}
                    >
                        <p style={{ margin: "0", fontSize: "1.3rem" }}>
                            Em breve você receberá propostas com valores e prazo de entrega para seu job.
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        lineColor={"orange"}
                        iconStyle={iconStyle}
                        icon={<RiNumber2 />}
                    >
                        <p style={{ margin: "0", fontSize: "1.3rem" }}>
                            Avalie a melhor proposta para a sua solicitação, analisando o valor, prazo e portfólio do
                            fotógrafo. Caso tenha dúvidas você poderá trocar mensagens diretamente com o fotógrafo pelo
                            seu painel do cliente.
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        lineColor={"orange"}
                        iconStyle={iconStyle}
                        icon={<RiNumber3 />}
                    >
                        <p style={{ margin: "0", fontSize: "1.3rem" }}>
                            Após escolher a proposta que mais te agrada você deverá efetuar o pagamento seguro pelo seu
                            painel de cliente.
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        lineColor={"orange"}
                        iconStyle={iconStyle}
                        icon={<RiNumber4 />}
                    >
                        <p style={{ margin: "0", fontSize: "1.3rem" }}>
                            As fotos serão entregues dentro da plataforma para que você faça o download com facilidade.
                        </p>
                    </VerticalTimelineElement>
                </VerticalTimeline>
            </TimeLineContent>

            <Footer>
                <Link href={`/marketplace/jobs/${jobId}`}>
                    <Button block style={{ maxWidth: "33.875rem" }}>
                        <a style={{ color: "inherit", textDecoration: "none" }}>Acompanhar solicitação</a>
                    </Button>
                </Link>
            </Footer>
        </>
    );
};

export default Success;
